import { render, staticRenderFns } from "./saleafter.vue?vue&type=template&id=4c8d42ea&scoped=true&"
import script from "./saleafter.vue?vue&type=script&lang=js&"
export * from "./saleafter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8d42ea",
  null
  
)

export default component.exports